module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 113);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports) {

module.exports = require("@splunk/themes");

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = require("prop-types");

/***/ }),

/***/ 113:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, "default", function() { return /* reexport */ ColumnLayout_ColumnLayout; });
__webpack_require__.d(__webpack_exports__, "Column", function() { return /* reexport */ ColumnLayout_Column; });
__webpack_require__.d(__webpack_exports__, "Row", function() { return /* reexport */ ColumnLayout_Row; });

// EXTERNAL MODULE: external "react"
var external_react_ = __webpack_require__(2);
var external_react_default = /*#__PURE__*/__webpack_require__.n(external_react_);

// EXTERNAL MODULE: external "prop-types"
var external_prop_types_ = __webpack_require__(1);
var external_prop_types_default = /*#__PURE__*/__webpack_require__.n(external_prop_types_);

// EXTERNAL MODULE: external "@splunk/themes/useSplunkTheme"
var useSplunkTheme_ = __webpack_require__(38);
var useSplunkTheme_default = /*#__PURE__*/__webpack_require__.n(useSplunkTheme_);

// EXTERNAL MODULE: external "lodash"
var external_lodash_ = __webpack_require__(4);

// EXTERNAL MODULE: external "styled-components"
var external_styled_components_ = __webpack_require__(3);
var external_styled_components_default = /*#__PURE__*/__webpack_require__.n(external_styled_components_);

// EXTERNAL MODULE: external "@splunk/themes"
var themes_ = __webpack_require__(0);

// CONCATENATED MODULE: ./src/ColumnLayout/ColumnStyles.ts


var Styled = external_styled_components_default.a.div.withConfig({
  displayName: "ColumnStyles__Styled",
  componentId: "sc-1pchz98-0"
})(["", ";"], themes_["mixins"].reset('block'));

// EXTERNAL MODULE: ./src/utils/types.ts
var types = __webpack_require__(48);

// CONCATENATED MODULE: ./src/ColumnLayout/Column.tsx
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }






var propTypes = {
  children: external_prop_types_default.a.node,
  elementRef: external_prop_types_default.a.oneOfType([external_prop_types_default.a.func, external_prop_types_default.a.object]),

  /** @private. */
  gutter: external_prop_types_default.a.number,

  /** @private. */
  isFirstChild: external_prop_types_default.a.bool,

  /** @private. */
  isLastChild: external_prop_types_default.a.bool,
  span: external_prop_types_default.a.number,

  /** @private. */
  style: external_prop_types_default.a.object
};

function Column(_ref) {
  var children = _ref.children,
      elementRef = _ref.elementRef,
      gutter = _ref.gutter,
      _ref$span = _ref.span,
      span = _ref$span === void 0 ? 1 : _ref$span,
      isFirstChild = _ref.isFirstChild,
      isLastChild = _ref.isLastChild,
      style = _ref.style,
      otherProps = _objectWithoutProperties(_ref, ["children", "elementRef", "gutter", "span", "isFirstChild", "isLastChild", "style"]);

  // @docs-props-type ColumnPropsBase
  var width = gutter ? "calc((100% - ".concat(11 * gutter, "px) * ").concat(span / 12, " + (").concat(gutter, "px * ").concat(span - 1, "))") : "".concat(100 / 12 * span, "%");
  Object(types["a" /* assertDefined */])(gutter);
  var calcStyle = {
    marginLeft: isFirstChild ? undefined : gutter / 2,
    marginRight: isLastChild ? undefined : gutter / 2,
    flex: "".concat(span, " ").concat(span, " auto"),
    // may accommodate small rounding errors and dividers
    width: width
  };
  return /*#__PURE__*/external_react_default.a.createElement(Styled, _extends({
    "data-test": "column",
    ref: elementRef,
    style: Object(external_lodash_["defaults"])({}, style, calcStyle)
  }, otherProps), children);
}

Column.propTypes = propTypes;
/* harmony default export */ var ColumnLayout_Column = (Column);
// CONCATENATED MODULE: ./src/ColumnLayout/RowStyles.ts


var RowStyles_Styled = external_styled_components_default.a.div.withConfig({
  displayName: "RowStyles__Styled",
  componentId: "sc-121ntds-0"
})(["", ";flex-flow:row nowrap;&[data-align-items='start']{align-items:flex-start;}&[data-align-items='end']{align-items:flex-end;}&[data-align-items='center']{align-items:center;}&[data-align-items='stretch']{align-items:stretch;}"], themes_["mixins"].reset('flex'));
var StyledDivider = external_styled_components_default.a.div.withConfig({
  displayName: "RowStyles__StyledDivider",
  componentId: "sc-121ntds-1"
})(["border-left:1px solid ", ";flex:0 0 1;align-self:stretch;"], Object(themes_["pick"])({
  prisma: themes_["variables"].neutral200,
  enterprise: {
    light: themes_["variables"].gray92,
    dark: themes_["variables"].gray60
  }
}));

// CONCATENATED MODULE: ./src/ColumnLayout/Row.tsx
function Row_extends() { Row_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return Row_extends.apply(this, arguments); }

function Row_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = Row_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function Row_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }






var Row_propTypes = {
  alignItems: external_prop_types_default.a.oneOf(['start', 'end', 'center', 'stretch']),
  children: external_prop_types_default.a.node,

  /** @private. */
  divider: external_prop_types_default.a.bool,
  elementRef: external_prop_types_default.a.oneOfType([external_prop_types_default.a.func, external_prop_types_default.a.object]),

  /** @private. */
  gutter: external_prop_types_default.a.number,

  /** @private. */
  isFirstChild: external_prop_types_default.a.bool,

  /** @private. */
  isLastChild: external_prop_types_default.a.bool,

  /** @private. */
  style: external_prop_types_default.a.object
};

function Row(_ref) {
  var _ref$alignItems = _ref.alignItems,
      alignItems = _ref$alignItems === void 0 ? 'stretch' : _ref$alignItems,
      children = _ref.children,
      divider = _ref.divider,
      elementRef = _ref.elementRef,
      gutter = _ref.gutter,
      isFirstChild = _ref.isFirstChild,
      isLastChild = _ref.isLastChild,
      style = _ref.style,
      otherProps = Row_objectWithoutProperties(_ref, ["alignItems", "children", "divider", "elementRef", "gutter", "isFirstChild", "isLastChild", "style"]);

  // @docs-props-type RowPropsBase
  if (false) { var total; }

  var cloneColumn = Object(external_react_["useCallback"])(function (column, idx) {
    return /*#__PURE__*/Object(external_react_["cloneElement"])(column, {
      gutter: gutter,
      isFirstChild: idx === 0,
      isLastChild: idx === external_react_["Children"].count(children) - 1
    });
  }, [children, gutter]);
  var insertDividers = Object(external_react_["useCallback"])(function (acc, row, idx, original) {
    acc.push(row);

    if (divider && idx < original.length - 1) {
      acc.push( /*#__PURE__*/external_react_default.a.createElement(StyledDivider, {
        key: "".concat(idx, "-divider")
      }));
    }

    return acc;
  }, [divider]);
  Object(types["a" /* assertDefined */])(gutter);
  var gutterStyle = {
    marginTop: isFirstChild ? undefined : gutter / 2,
    marginBottom: isLastChild ? undefined : gutter / 2
  };
  var childrenCloned = external_react_["Children"].toArray(children).filter(external_react_["isValidElement"]).map(cloneColumn).reduce(insertDividers, []);
  return /*#__PURE__*/external_react_default.a.createElement(RowStyles_Styled, Row_extends({
    style: Object(external_lodash_["defaults"])({}, style, gutterStyle),
    "data-align-items": alignItems,
    "data-test": "row",
    ref: elementRef
  }, otherProps), childrenCloned);
}

Row.propTypes = Row_propTypes;
/* harmony default export */ var ColumnLayout_Row = (Row);
// CONCATENATED MODULE: ./src/ColumnLayout/ColumnLayoutStyles.ts


var ColumnLayoutStyles_Styled = external_styled_components_default.a.div.withConfig({
  displayName: "ColumnLayoutStyles__Styled",
  componentId: "sc-3eatxz-0"
})(["", ";flex-direction:column;"], themes_["mixins"].reset('flex'));
var ColumnLayoutStyles_StyledDivider = external_styled_components_default.a.div.withConfig({
  displayName: "ColumnLayoutStyles__StyledDivider",
  componentId: "sc-3eatxz-1"
})(["border-top:1px solid ", ";height:0;"], Object(themes_["pick"])({
  prisma: themes_["variables"].neutral200,
  enterprise: {
    light: themes_["variables"].gray92,
    dark: themes_["variables"].gray60
  }
}));

// CONCATENATED MODULE: ./src/ColumnLayout/ColumnLayout.tsx
function ColumnLayout_extends() { ColumnLayout_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return ColumnLayout_extends.apply(this, arguments); }

function ColumnLayout_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = ColumnLayout_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function ColumnLayout_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }







var ColumnLayout_propTypes = {
  children: external_prop_types_default.a.node,
  divider: external_prop_types_default.a.oneOf(['none', 'vertical', 'horizontal']),
  elementRef: external_prop_types_default.a.oneOfType([external_prop_types_default.a.func, external_prop_types_default.a.object]),
  gutter: external_prop_types_default.a.number
};

/**
 * `ColumnLayout` provides simple API for laying out content into columns. It is based on flexbox
 * and has 12 columns.
 */
function ColumnLayout(_ref) {
  var children = _ref.children,
      _ref$divider = _ref.divider,
      divider = _ref$divider === void 0 ? 'none' : _ref$divider,
      elementRef = _ref.elementRef,
      gutterProp = _ref.gutter,
      otherProps = ColumnLayout_objectWithoutProperties(_ref, ["children", "divider", "elementRef", "gutter"]);

  // @docs-props-type ColumnLayoutPropsBase
  var _useSplunkTheme = useSplunkTheme_default()(),
      family = _useSplunkTheme.family,
      density = _useSplunkTheme.density;

  var cloneRow = Object(external_react_["useCallback"])(function (row, idx) {
    var isFirstChild = idx === 0;
    var isLastChild = idx === external_react_["Children"].count(children) - 1;
    var gutter = gutterProp;

    if (gutter === undefined) {
      if (family === 'prisma') {
        if (density === 'compact') {
          gutter = 16;
        } else if (density === 'comfortable') {
          gutter = 24;
        }
      } else if (family === 'enterprise') {
        gutter = 30;
      }
    }

    return /*#__PURE__*/Object(external_react_["cloneElement"])(row, {
      gutter: gutter,
      divider: divider === 'vertical',
      isFirstChild: isFirstChild,
      isLastChild: isLastChild
    });
  }, [children, density, divider, family, gutterProp]);
  var insertDividers = Object(external_react_["useCallback"])(function (acc, row, idx, original) {
    acc.push(row);

    if (divider === 'horizontal' && idx < original.length - 1) {
      acc.push( /*#__PURE__*/external_react_default.a.createElement(ColumnLayoutStyles_StyledDivider, {
        key: "".concat(idx, "-divider")
      }));
    }

    return acc;
  }, [divider]);
  var childrenCloned = external_react_["Children"].toArray(children).filter(external_react_["isValidElement"]).map(cloneRow).reduce(insertDividers, []);
  return /*#__PURE__*/external_react_default.a.createElement(ColumnLayoutStyles_Styled, ColumnLayout_extends({
    "data-test": "column-layout",
    ref: elementRef
  }, otherProps), childrenCloned);
}

ColumnLayout.propTypes = ColumnLayout_propTypes;
ColumnLayout.Row = ColumnLayout_Row;
ColumnLayout.Column = ColumnLayout_Column;
/* harmony default export */ var ColumnLayout_ColumnLayout = (ColumnLayout);

// CONCATENATED MODULE: ./src/ColumnLayout/index.ts



/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = require("styled-components");

/***/ }),

/***/ 38:
/***/ (function(module, exports) {

module.exports = require("@splunk/themes/useSplunkTheme");

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

module.exports = require("lodash");

/***/ }),

/***/ 48:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return assertDefined; });
// see https://github.com/DefinitelyTyped/DefinitelyTyped/issues/31245 for details
// regarding the css prop. certain (versions of) libraries included in the compilation
// - such as storybook->emotion - introduce the css prop using a global augmentation,
// which causes the prop to end up in our declaration files (via JSX.IntrinsicElements).
// it's difficult to control all nested dependencies and their types, which is why the
// css prop is omitted in the two prop helpers above - this ensures the css prop isn't
// erroneously included in react-ui's public api.
// see https://github.com/microsoft/TypeScript/pull/12253
// see https://www.typescriptlang.org/docs/handbook/release-notes/typescript-3-7.html
function assertDefined(val, msg) {
  if (val === undefined || val === null) {
    throw new Error(msg !== null && msg !== void 0 ? msg : 'Unexpected undefined or null');
  }
}



/***/ })

/******/ });